import { apiService } from "./api";

export const companyService = {
  // Get all companies (super_admin only)
  getCompanies: async (page = 1, limit = 10, search = "", status = "") => {
    const params = { page, limit };
    if (search) params.search = search;
    if (status && status !== "all") params.status = status;

    return await apiService.get("/companies", { params });
  },

  // Get company by ID (super_admin only)
  getCompanyById: async (id) => {
    return await apiService.get(`/companies/${id}`);
  },

  // Create company (super_admin only)
  createCompany: async (companyData) => {
    return await apiService.post("/companies", companyData);
  },

  // Update company (super_admin only)
  updateCompany: async (id, companyData) => {
    return await apiService.put(`/companies/${id}`, companyData);
  },

  // Delete company (super_admin only)
  deleteCompany: async (id) => {
    return await apiService.delete(`/companies/${id}`);
  },

  // Get company statistics (super_admin only)
  getCompanyStats: async () => {
    return await apiService.get("/companies/stats");
  },

  // Get users in a company (super_admin only)
  getCompanyUsers: async (companyId, page = 1, limit = 10) => {
    const params = { page, limit };
    return await apiService.get(`/companies/${companyId}/users`, { params });
  },
};

export default companyService;
